import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "typeSelect",
    "googleFields",
    "messageLabel",
    "messageBody",
    "googleHint",
    "row",
    "destroyInput"
  ]

  connect() {
    this.updateVisibility()
  }

  typeChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    if (!this.hasTypeSelectTarget) return

    const isGoogle = this.typeSelectTarget.value === "google_review"

    if (this.hasGoogleFieldsTarget) {
      this.googleFieldsTarget.style.display = isGoogle ? "block" : "none"
    }
    if (this.hasGoogleHintTarget) {
      this.googleHintTarget.style.display = isGoogle ? "block" : "none"
    }
    if (this.hasMessageBodyTarget) {
      this.messageBodyTarget.placeholder = isGoogle
        ? "Adoraríamos um comentário seu no Google: {url}"
        : "Ex.: Obrigado pela avaliação! Nos siga no Instagram @..."
    }
  }

  remove(event) {
    event.preventDefault()
    if (this.hasDestroyInputTarget) {
      this.destroyInputTarget.value = "1"
    }
    if (this.hasRowTarget) {
      this.rowTarget.style.display = "none"
    } else {
      this.element.style.display = "none"
    }
  }
}
